import styled from 'styled-components'

export const Button = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 44px;
  width: 100%;
  font-size: 18px;
  font-weight: 700;
  color: ${(props) => props.theme.colours.surfaceText.ST100};
  background-image: ${(props) => props.theme.colours.actionsPrimary.AP050G};
  border: 0.7px solid #f7bf4a;
  border-radius: 6px;
  box-shadow: 0px 3px 0px #b5892e, 0px 6px 3px rgba(0, 0, 0, 0.25);
  outline: none;
  position: relative;
  z-index: 50;

  &:active {
    padding-top: 3px;
    box-shadow: 0px 1px 0px #b5892e, 0px 2px 3px rgba(0, 0, 0, 0.25);
  }

  &:hover {
    background-image: linear-gradient(#f6b52d 100%, #f6b52d 100%);
  }

  &:disabled {
    color: ${(props) => props.theme.colours.neutrals.N030};
    background-image: linear-gradient(#3a3a48 100%, #3a3a48 100%);
    border: 0.7px solid #3a3a48;
    box-shadow: 0px 6px 3px rgba(0, 0, 0, 0.25);
  }

  .stake {
    font-size: 16px;
    font-weight: 500;
    margin-left: 8px;
    path {
      fill: ${(props) => props.theme.colours.surfaceText.ST100};
    }
  }
`
